import styled from 'styled-components';

export const Container = styled.div`
  grid-area: title;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #eee;
  border: 1px solid gray;
  border-radius: 3px;
  & h1 {
    font-size: 2.5em;
    padding: 0px;
    margin: 0px;
  }
`;

export default Container;
